
/* ------------------------------------------------------------------------ */
/*		File: meta.tsx                                                      */
/*		Description: Component implementation                               */
/*		Project: iSymWebSchool											    */
/*		Author: ISym Global Solutions Limited                               */
/*		Version: 1.0													    */
/* ------------------------------------------------------------------------ */

/* eslint-disable react/jsx-pascal-case */

import React, { memo } from 'react';
import { Helmet } from 'react-helmet-async';
import metas from "../../i18n/locales/metas.json";

interface ICard {
    page: string;
}

interface MetaData {
    title: string;
    description: string;
    keywords: string;
}

const defaultMeta: MetaData = {
    title: "Live Online English Courses | Ireland, Europe & US | ISYM | Cursos de inglés en línea en vivo | Irlanda, Europa y EE.UU. | ISYM",
    description: "ISYM offers live, interactive online English courses for students in Ireland, Europe, and the US. Learn in real-time with expert instructors. Enrol today!. ISYM ofrece cursos de inglés en línea interactivos y en vivo para estudiantes en Irlanda, Europa y EE. UU. Aprende en tiempo real con instructores expertos. ¡Inscríbete hoy!",
    keywords: "live online English language school Ireland, live online English language school Europe, live online English language school US, escuela de inglés en línea en vivo en Irlanda, escuela de inglés en línea en vivo en Europa, escuela de inglés en línea en vivo en EE. UU."

};

const Meta: React.FC<ICard> = memo(({ page }) => {
    // Obtén los metadatos o usa los valores por defecto
    const meta = page in metas ? metas[page as keyof typeof metas] : defaultMeta;



    return (
        <Helmet>
            <title>{meta.title}</title>
            <meta name="description" content={meta.description} />
            <meta name="keywords" content={meta.keywords} />

            {/* Open Graph */}
            <meta property="og:title" content={meta.title} />
            <meta property="og:description" content={meta.description} />
            <meta property="og:type" content="website" />
            {/* Twitter Cards */}
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={meta.title} />
            <meta name="twitter:description" content={meta.description} />
        </Helmet>
    );
});

export default Meta;
